<template>
  <el-dialog title="请确认您的操作!" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <div class="text-center">
      <p>确定删除会员信息</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteShopVipUser">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopVipUser } from '@/api/user/shopVipUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteShopVipUser',
  data() {
    return {
      dialogVisible: false,
      deleteShopVipUserInfo: {}
    }
  },
  methods: {
    open(shopVipUser) {
      this.dialogVisible = true
      this.deleteShopVipUserInfo = { ...shopVipUser }
    },
    handleClose() {
      this.deleteShopVipUserInfo = {}
    },
    async deleteShopVipUser() {
      try {
        this.deleteShopVipUserInfo.shopId = getShopId()
        const res = await deleteShopVipUser(this.deleteShopVipUserInfo)
        console.log(res)
        this.$message.success('删除成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('删除会员失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}
</style>